export const botonicUpdateUserExtraData = (extraData: any) => {
  // @ts-ignore
  window.Botonic && window.Botonic.updateUser({ extra_data: extraData })
}
